import React from 'react'
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"
import Topheader from '../Home/topHeader/Topheader'
import Middlebar from '../Home/middleBar/Middlebar'
import NavMenu from '../Home/navigationBar/NavMenu'
import Footer from '../Home/footer/Footer'

const images = [
  "o1.jpg",
  "o2.jpg",
  "o3.jpg",
  "o4.jpg",
  "o5.jpg",
  "o6.jpg",
  "o7.jpg",
  "o8.jpg",
  "o9.jpg",
  "o10.jpg",
  "o11.jpg",
  "o12.jpg",
  "o13.jpg",
  "o14.jpg",
  "o15.jpg",

]
const Orientation = () => {
  return (
    <>
    <Topheader/>
    <Middlebar/>
    <NavMenu/>
      <div className="p-5 mb-5">
        <div className="head my-3 mt-6">
          <h1 className="text-6xl flex justify-center font-monserrat text-maroon">ORIENTATION CEREMONY</h1>
        </div>
        <div className="p-20 -mt-10">

        <ResponsiveMasonry
                columnsCountBreakPoints={{350: 1, 750: 2, 1000: 3}}
                >
                <Masonry gutter='15px'>
                    {images.map((image, i) => (
                      <img
                      key={i}
                      src={image}
                      // style={{width: "100%", display: "block"}}
                      className="w-1000 block rounded-lg"
                      alt=""
                      />
                      ))}
                </Masonry>
            </ResponsiveMasonry>
                      </div>
                </div> 
            <Footer/> 
    </>
  )
}

export default Orientation
